import { getTENANTLayerId } from './orionUtils';
import { toast } from '@appd/uik';

export interface UserDashboardPermissions {
  canCreateDashboards: boolean;
  canUpdateDashboards: boolean;
  canDeleteDashboards: boolean;
}

export const noDashboardPermissions = {
  canCreateDashboards: false,
  canUpdateDashboards: false,
  canDeleteDashboards: false,
};

export const fullDashboardPermissions = {
  canCreateDashboards: true,
  canUpdateDashboards: true,
  canDeleteDashboards: true,
};

export const getIAMPermissions = (): Promise<UserDashboardPermissions> => {
  const dashboardPermissionsBody = {
    filters: {
      permissions: ['platformui:createDashboard', 'platformui:updateDashboard', 'platformui:deleteDashboard'],
      solutions: ['platformui'],
    },
  };
  const initialRequest = new Request('/session/api/ext/iam/policy-admin/v1beta2/principals/self/permissions', {
    headers: {
      Accept: 'application/json; charset=UTF-8',
      'layer-type': 'TENANT',
      'layer-id': getTENANTLayerId(),
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify(dashboardPermissionsBody),
  });
  const fetchFailedToast = () => {
    toast({
      copy: false,
      description: 'Dashboard Permissions Fetch Failed',
      icon: 'ERROR',
      title: 'ERROR',
    });
  };

  return fetch(initialRequest)
    .then(response => response.text())
    .then(data => (data ? JSON.parse(data) : {}))
    .then((response: any) => {
      if (response.items) {
        const permissionIdList = response.items?.map((item: any) => item.id);
        return {
          canCreateDashboards: permissionIdList.includes('platformui:createDashboard'),
          canUpdateDashboards: permissionIdList.includes('platformui:updateDashboard'),
          canDeleteDashboards: permissionIdList.includes('platformui:deleteDashboard'),
        } as UserDashboardPermissions;
      }
      fetchFailedToast();
      return noDashboardPermissions;
    })
    .catch(() => {
      fetchFailedToast();
      return noDashboardPermissions;
    });
};
